<template>
  <article class="person">
    <a class="person-link" :href="person.url">
      View Profile
    </a>
    <div class="avatar-wrap" :class="badge_class">
      <img class="avatar-bg cm_bg" :src="person.avatar || avatar" :alt="fullName" loading="lazy" />
      <ChapterBox v-if="person.chapter" :chapter='person.chapter' :badge="person.team_badge" />
    </div>
    <div class="person-text">
      <h1 class="person-name">{{ fullName }}</h1>
      <p v-if="description" class="person-description">
        {{ description }}
      </p>
      <div v-if="person.location" class="person-location">{{ person.location }}</div>
    </div>
  </article>
</template>

<script>
import ChapterBox from "./chapter-box";

export default {
  components: {
    ChapterBox
  },

  props: {
    person: {
      type: Object
    }
  },

  data() {
    return {};
  },

  computed: {
    fullName: function() {
      return this.person.firstname + " " + this.person.lastname;
    },

    description: function() {
      if (this.person.job_title && this.person.company_name) {
        return this.person.job_title + " at " + this.person.company_name;
      } else if (this.person.job_title) {
        return this.person.job_title;
      } else if (this.person.company_name) {
        return this.person.company_name;
      }
    },

    badge_class: function() {
      if (this.person.chapter) {
        return "ch_" + this.person.chapter.id;
      }
    },

    avatar: function() {
      let i = parseInt(this.person.id.toString().slice(-1));
      let hash =
        i < 8 ? (i < 4 ? i % 4 : i % 2 + 1) : Math.floor(i % 1.5 + 2.5);
      return `/images/avatars/cm-avatar-${hash}.svg`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// app/javascript/company/individual-card.vue?7208eaa6